<template>
<e-chart ref="chart" />
</template>

<script>
// import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'CalendarChart',
  props: {
    data: {
      required: true,
      type: Array
    },
    month: {
      required: true,
      type: String
    },
    maxAuditStage: {
      required: true,
      type: Number
    },
    currentSiteDevice: {
      required: true,
      type: Object
    }
  },
  methods: {
    getData () {
      let {data} = this
      return data.map(el => {
        return el.data
      })
    },
    render (isReal) {
      // console.log(this.getData(), this.month)
      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {},
        visualMap: [{
          show: false,
          type: 'piecewise',
          orient: 'horizontal',
          pieces: [
            {min: 300, color: '#fff'},
            {min: 200, max: 300, color: '#fff'},
            {min: 150, max: 200, color: '#fff'},
            {min: 100, max: 150, color: '#fff'},
            {min: 50, max: 100, color: '#fff'},
            {min: 0, max: 50, color: '#fff'}
          ],
          left: 'center',
          top: 30
        }],
        calendar: [{
          left: 'center',
          top: 'middle',
          cellSize: [70, 70],
          yearLabel: { show: false },
          orient: 'vertical',
          dayLabel: {
            firstDay: 1,
            nameMap: 'cn'
          },
          monthLabel: { show: false },
          range: this.month
        }],
        series: [{
          type: 'heatmap',
          coordinateSystem: 'calendar',
          calendarIndex: 0,
          tooltip: { show: false },
          data: this.getData()
        }, {
          type: 'scatter',
          coordinateSystem: 'calendar',
          calendarIndex: 0,
          symbolSize: 0,
          label: {
            show: true,
            formatter: function (params) {
              let data = params.value

              return new Date(data[0]).getDate()
            },
            fontSize: 20,
            color: '#000'
          },
          tooltip: {
            position: 'inside',
            formatter: function (param) {
              let data = param.value
              let str = ``
              data.forEach(item => {
                if (Array.isArray(item)) {
                  let color = item[0] === '--' ? '#909399' : (item[0] ? '#67C23A' : '#E6A23C')
                  str = str + `<p style="padding: 3px; text-align: center; background: ${color};">${item[1] === '--' ? '未审核' : item[1]}</p>`
                }
              })
              return `
                <div style="width: 200px;">
                  <h3 style="margin 0;">${data[0]}</h3>
                  ${str}
                </div>
              `
            },
            padding: [0, 5],
            borderColor: '#FFF'
          },
          data: this.getData()
        }]
      }
      // console.log(chartOpt)

      this.$refs.chart.setOpt(chartOpt)
      this.$refs.chart.resize()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/CalendarChart.vue